"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
require("react-quill-new/dist/quill.snow.css");
var MechanicsForm_1 = __importDefault(require("./MechanicsForm"));
var react_1 = require("react");
var modalSlice_1 = require("@store/slices/modalSlice");
var mechanicsSlice_1 = require("@store/slices/mechanicsSlice");
var modalSlice_2 = require("@store/slices/modalSlice");
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var mechanicsFormTranslator_1 = require("./localisation/mechanicsFormTranslator");
var mechanicsAPI_1 = require("@services/mechanicsAPI");
var loaderSlice_1 = require("@store/slices/loaderSlice");
var initialState = {
    name: "",
    description: "",
    type_id: null,
    examples: [],
};
function NewMechanicForm() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(initialState), formData = _a[0], setFormData = _a[1];
    var gddId = (0, react_redux_1.useSelector)(function (state) { return state.gddSlice.gdd; }).id;
    var currentLanguage = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = mechanicsFormTranslator_1.mechanicsFormTranslator[currentLanguage];
    function handleFormSubmit() {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (formData.name.length <= 0)
                            return [2 /*return*/, false];
                        dispatch((0, loaderSlice_1.setLoading)(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, mechanicsAPI_1.createMechanicAPI)(__assign(__assign({}, formData), { gdd_id: gddId }))];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            dispatch((0, mechanicsSlice_1.addMechanic)(res.mechanic));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({
                            activeModal: modalSlice_2.ActiveModal.Info,
                            text: "something went wrong",
                        }));
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch((0, loaderSlice_1.setLoading)(false));
                        return [7 /*endfinally*/];
                    case 5:
                        dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_2.ActiveModal.Info, text: loc.success }));
                        setFormData(initialState);
                        return [2 /*return*/, true];
                }
            });
        });
    }
    return ((0, jsx_runtime_1.jsx)(MechanicsForm_1.default, { formData: formData, setFormData: setFormData, handleFormSubmit: handleFormSubmit, language: loc }));
}
exports.default = NewMechanicForm;
